import { defineHotpadsEvent, trackHotpadsEventDefinition } from '../track';
import type { FilterTriggerLocation, FilterTriggerObject } from './types';

const LEGACY_SOURCE = 'srcLegacy/shared/models/Clickstream/FilterClickstreamEvents.ts';

const BEDROOM_FILTER = defineHotpadsEvent({
  key: 'filters.bedroom',
  eventTypeId: '5816',
  eventTypeVersionId: '2',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackBedroomFilterEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'bedroom_filter',
    object: 'filter_panel',
  },
  semanticEvent: 'bedroom_filter',
});

const BATHROOM_FILTER = defineHotpadsEvent({
  key: 'filters.bathroom',
  eventTypeId: '5817',
  eventTypeVersionId: '2',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackBathroomFilterEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'bathroom_filter',
    object: 'filter_panel',
  },
  semanticEvent: 'bathroom_filter',
});

const PETS_FILTER = defineHotpadsEvent({
  key: 'filters.pets',
  eventTypeId: '5818',
  eventTypeVersionId: '2',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackPetsFilterEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'pets_filter',
    object: 'filter_panel',
  },
  semanticEvent: 'pets_filter',
});

const LOW_PRICE_FILTER = defineHotpadsEvent({
  key: 'filters.low_price',
  eventTypeId: '5819',
  eventTypeVersionId: '4',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackLowPriceFilterEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'low_price_slider',
    object: 'filter_panel',
  },
  semanticEvent: 'low_price_filter',
});

const HIGH_PRICE_FILTER = defineHotpadsEvent({
  key: 'filters.high_price',
  eventTypeId: '5820',
  eventTypeVersionId: '4',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackHighPriceFilterEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'high_price_slider',
    object: 'filter_panel',
  },
  semanticEvent: 'high_price_filter',
});

const LAUNDRY_FILTER = defineHotpadsEvent({
  key: 'filters.laundry',
  eventTypeId: '5884',
  eventTypeVersionId: '2',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackLaundryFilterEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'laundry_filter_checkbox',
    object: 'filter_panel',
  },
  semanticEvent: 'laundry_filter',
});

const AC_FILTER = defineHotpadsEvent({
  key: 'filters.ac',
  eventTypeId: '5885',
  eventTypeVersionId: '2',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackAcFilterEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'ac_filter_checkbox',
    object: 'filter_panel',
  },
  semanticEvent: 'ac_filter',
});

const HEATING_FILTER = defineHotpadsEvent({
  key: 'filters.heating',
  eventTypeId: '5886',
  eventTypeVersionId: '2',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackHeatingFilterEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'heating_filter_checkbox',
    object: 'filter_panel',
  },
  semanticEvent: 'heating_filter',
});

const PARKING_FILTER = defineHotpadsEvent({
  key: 'filters.parking',
  eventTypeId: '5887',
  eventTypeVersionId: '2',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackParkingFilterEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'parking_filter_checkbox',
    object: 'filter_panel',
  },
  semanticEvent: 'parking_filter',
});

const GATED_FILTER = defineHotpadsEvent({
  key: 'filters.gated_entry',
  eventTypeId: '5888',
  eventTypeVersionId: '2',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackGatedFilterEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'gated_entry_filter_checkbox',
    object: 'filter_panel',
  },
  semanticEvent: 'gated_entry_filter',
});

const DOORMAN_FILTER = defineHotpadsEvent({
  key: 'filters.doorman',
  eventTypeId: '5889',
  eventTypeVersionId: '2',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackDoormanFilterEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'doorman_filter_checkbox',
    object: 'filter_panel',
  },
  semanticEvent: 'doorman_filter',
});

const GYM_FILTER = defineHotpadsEvent({
  key: 'filters.gym',
  eventTypeId: '5891',
  eventTypeVersionId: '2',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackGymFilterEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'gym_filter_checkbox',
    object: 'filter_panel',
  },
  semanticEvent: 'gym_filter_interaction',
});

const POOL_FILTER = defineHotpadsEvent({
  key: 'filters.pool',
  eventTypeId: '5893',
  eventTypeVersionId: '2',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackPoolFilterEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'pool_filter_checkbox',
    object: 'filter_panel',
  },
  semanticEvent: 'pool_filter',
});

const DISHWASHER_FILTER = defineHotpadsEvent({
  key: 'filters.dishwasher',
  eventTypeId: '5894',
  eventTypeVersionId: '2',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackDishwasherFilterEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'dishwasher_filter_checkbox',
    object: 'filter_panel',
  },
  semanticEvent: 'dishwasher_filter',
});

const FURNISHED_FILTER = defineHotpadsEvent({
  key: 'filters.furnished',
  eventTypeId: '5895',
  eventTypeVersionId: '2',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackFurnishedEventEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'furnished_filter_checkbox',
    object: 'filter_panel',
  },
  semanticEvent: 'furnished_filter',
});

const RESET_FILTER = defineHotpadsEvent({
  key: 'filters.reset',
  eventTypeId: '5992',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackResetFilterEvent',
  trigger: {
    type: 'interaction',
    location: 'hp_homepage',
    source: 'link_to_reset_filters',
    object: 'hp_home_page_component|search',
  },
  semanticEvent: 'reset_filter',
});

export function emitTrackBedroomFilterEvent({
  triggerLocation,
  triggerObject,
}: {
  triggerLocation: FilterTriggerLocation;
  triggerObject: FilterTriggerObject;
}) {
  trackHotpadsEventDefinition(BEDROOM_FILTER, { triggerLocation, triggerObject });
}

export function emitTrackBathroomFilterEvent({ triggerLocation }: { triggerLocation: FilterTriggerLocation }) {
  trackHotpadsEventDefinition(BATHROOM_FILTER, { triggerLocation });
}

export function emitTrackPetsFilterEvent({ triggerLocation }: { triggerLocation: FilterTriggerLocation }) {
  trackHotpadsEventDefinition(PETS_FILTER, { triggerLocation });
}

export function emitTrackLowPriceFilterEvent({
  triggerLocation,
  triggerObject,
}: {
  triggerLocation: FilterTriggerLocation;
  triggerObject: string;
}) {
  trackHotpadsEventDefinition(LOW_PRICE_FILTER, { triggerLocation, triggerObject });
}

export function emitTrackHighPriceFilterEvent({
  triggerLocation,
  triggerObject,
}: {
  triggerLocation: FilterTriggerLocation;
  triggerObject: string;
}) {
  trackHotpadsEventDefinition(HIGH_PRICE_FILTER, { triggerLocation, triggerObject });
}

export const emitTrackLaundryFilterEvent = ({ triggerLocation }: { triggerLocation?: FilterTriggerLocation } = {}) =>
  trackHotpadsEventDefinition(LAUNDRY_FILTER, { triggerLocation });
export const emitTrackAcFilterEvent = ({ triggerLocation }: { triggerLocation?: FilterTriggerLocation } = {}) =>
  trackHotpadsEventDefinition(AC_FILTER, { triggerLocation });
export const emitTrackHeatingFilterEvent = ({ triggerLocation }: { triggerLocation?: FilterTriggerLocation } = {}) =>
  trackHotpadsEventDefinition(HEATING_FILTER, { triggerLocation });
export const emitTrackParkingFilterEvent = ({ triggerLocation }: { triggerLocation?: FilterTriggerLocation } = {}) =>
  trackHotpadsEventDefinition(PARKING_FILTER, { triggerLocation });
export const emitTrackGatedFilterEvent = ({ triggerLocation }: { triggerLocation?: FilterTriggerLocation } = {}) =>
  trackHotpadsEventDefinition(GATED_FILTER, { triggerLocation });
export const emitTrackDoormanFilterEvent = ({ triggerLocation }: { triggerLocation?: FilterTriggerLocation } = {}) =>
  trackHotpadsEventDefinition(DOORMAN_FILTER, { triggerLocation });
export const emitTrackGymFilterEvent = ({ triggerLocation }: { triggerLocation?: FilterTriggerLocation } = {}) =>
  trackHotpadsEventDefinition(GYM_FILTER, { triggerLocation });
export const emitTrackPoolFilterEvent = ({ triggerLocation }: { triggerLocation?: FilterTriggerLocation } = {}) =>
  trackHotpadsEventDefinition(POOL_FILTER, { triggerLocation });
export const emitTrackDishwasherFilterEvent = ({ triggerLocation }: { triggerLocation?: FilterTriggerLocation } = {}) =>
  trackHotpadsEventDefinition(DISHWASHER_FILTER, { triggerLocation });
export const emitTrackFurnishedEventEvent = ({ triggerLocation }: { triggerLocation?: FilterTriggerLocation } = {}) =>
  trackHotpadsEventDefinition(FURNISHED_FILTER, { triggerLocation });
export const emitTrackResetFilterEvent = () => trackHotpadsEventDefinition(RESET_FILTER);
